/**
 * Catálogo do domínio `posvendas` (T53, CAT-02).
 *
 * Origem: `src/shared/autorizacao/pos_vendas.ts`.
 *
 * `LEGADO.pos_vendas` aponta para **dois** papéis, `posvendas.escrita` e
 * `posvendas.upload` — é um dos três casos de "renomeação com upload" do §4.1.
 * A divisão aqui respeita isso: `edit` fica na escrita, `upload` na capacidade.
 * Somados, dão exatamente o `["read", "edit", "upload"]` de `pos_vendas.ts:11`.
 */
import type { NomePapel, Papel } from "../catalogo/vocabulario";

export const PAPEIS_POSVENDAS = {
  "posvendas.admin": {
    dominio: "posvendas",
    nivel: "admin",
    concessoes: [
      { acoes: ["manage"], recurso: "POSVENDAS" },
      // Conferência de acessos (POS-01): quem administra pós-vendas abre OS de field.
      { acoes: ["create", "read"], recurso: "OS_FIELD" },
    ],
  },
  "posvendas.escrita": {
    dominio: "posvendas",
    nivel: "escrita",
    concessoes: [{ acoes: ["read", "edit"], recurso: "POSVENDAS" }],
  },
  "posvendas.upload": {
    dominio: "posvendas",
    nivel: "upload",
    concessoes: [{ acoes: ["upload"], recurso: "POSVENDAS" }],
  },
  "posvendas.leitura": {
    dominio: "posvendas",
    nivel: "leitura",
    concessoes: [{ acoes: ["read"], recurso: "POSVENDAS" }],
  },
} as const satisfies Partial<Record<NomePapel, Papel>>;
